import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21eea8e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { style: {"width":"350px"} }
const _hoisted_3 = { style: {"max-height":"160px","overflow-y":"auto"} }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { style: {"max-width":"200px","font-size":"14px"} }
const _hoisted_8 = {
  class: "flex-ter-cen",
  style: {"color":"#d9001b"}
}
const _hoisted_9 = { key: 1 }

import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import { productStatsEnum } from '@/views/usercenter/Order/data'
import { isD2C, isJA, useRtfix } from '@/store'
import { useRouter } from 'vue-router'
import { Warning } from '@element-plus/icons-vue'
import dayjs from 'dayjs'
import { getOrderExpressListApi, queryUserMerchandiser } from '@/apis/order'
// open 打开物流弹窗

export default /*#__PURE__*/_defineComponent({
  props: ['row', 'cancelJump', 'orderNo', 'combineSku', 'showExpress'],
  emits: ['open'],
  setup(__props, { emit }) {

const props = __props

const router = useRouter()
// cancelJump 取消成功跳转取消商品页面
// showExpress 是否展开查看具体物流信息


const getText = (record?: any) => {
  const text = record.type === 1 ? t('预计发货时间') : t('预计到货时间')
  return text
}
const productStatsKeyEnum: any = {
  1: 'waitPurchaeQuantity',
  2: 'purchasingQuantity',
  3: 'hasPurchaeQuantity',
  4: 'expressQuantity',
  5: 'stockInQuantity',
  6: 'checkingQuantity',
  7: 'checkedQuantity',
  8: 'deliveredQuantity',
  9: 'hasDeliverQuantity',
  10: 'confirmQuantity',
  11: 'badClientQuantity',
  // 11: 'badClientQuantity',
  12: 'cancleAndRefundQuantity',
  13: 'keepStockQuantity',
  14: 'onTheWayFreezeQuantity'
}

const getMt8px = (k: number, isShowText: boolean) => {
  const arr = props.row?.orderItemStatus?.split(',') ?? []
  if (arr?.length < 2) {
    return ''
  }
  if (arr.includes(String(k)) && String(k) !== arr[0]) {
    return isShowText ? 'mt-16px display-block' : 'mt-8px'
  }
  return ''
}
/** 获取如果没有就显示无的文案 */
const getNoText = (status: number) => {
  const { purchaseMerchandiserList, expressDeliverGoodsList, purchaseArriveList } = getStatusData(status)
  // 当为已采购
  if (status === 3) {
    if (!Array.isArray(purchaseMerchandiserList) || !purchaseMerchandiserList?.length) {
      return t('预计发货时间：<br/>无')
    }
    return ''
  }
  //   国内运输中
  if (status === 4) {
    const isEmptyExpressList = !Array.isArray(expressDeliverGoodsList) || !expressDeliverGoodsList?.length
    const isEmptyPurchaseList = !Array.isArray(purchaseArriveList) || !purchaseArriveList?.length
    if (isEmptyExpressList && isEmptyPurchaseList) {
      return t('预计发货时间：<br/>无')
    }
    return ''
  }
  return ''
}
/** 获取展示文案 */
const getShowText = (itemData: any) => {
  if (!itemData || !itemData.length) {
    return null
  }
  const data = itemData.filter((item: any) => !!item.time)
  const text = itemData[0].type === 1 ? t('预计发货时间') : t('预计到货时间')
  const apostrophe = itemData.length > 2 ? ('<br/>' + '...') : ''
  if (!itemData[0].time || itemData[0].time === '-') {
    return text + '：' + '<br/>' + t('无2')
  }

  if (itemData.length >= 2) {
    const textTwo = !itemData[1].time || itemData[1].time === '-' ? t('无2') : itemData[1].time
    return text + '：' + '<br/>' + itemData[0].time + `(${t('X件').replace('X', itemData[0].num)})` + '<br/>' + textTwo + `(${t('X件').replace('X', itemData[1].num)})` + apostrophe
  }

  return text + '：' + '<br/>' + itemData[0].time + `(${t('X件').replace('X', itemData[0].num)})` + apostrophe
}
/** 获取不同状态下的数据 */
const getStatusData = (status: number) => {
  let purchaseMerchandiserList = []
  let expressDeliverGoodsList = []
  let purchaseArriveList = []
  // 当为已采购
  if (status === 3) {
    // purchaseMerchandiserList会出现为'-'的情况
    purchaseMerchandiserList = Array.isArray(props.row.purchaseMerchandiserList) ? props.row.purchaseMerchandiserList : []
  }
  //   当为国内运输中
  if (status === 4) {
    console.log(33333333333, props.row?.productSku, props.row)
    // expressMerchandiserList会出现为'-'的情况
    const data = Array.isArray(props.row?.expressMerchandiserList) ? props.row?.expressMerchandiserList : []
    // 时间类型：1 预计发货 2 预计到货
    expressDeliverGoodsList = data?.filter((item: any) => item.type === 1) ?? []
    purchaseArriveList = data?.filter((item: any) => item.type === 2) ?? []
  }
  return { purchaseMerchandiserList, expressDeliverGoodsList, purchaseArriveList }
}
// 汇总数据
const getTotalData = (status: number) => {
  const { purchaseMerchandiserList, expressDeliverGoodsList, purchaseArriveList } = getStatusData(status)
  return [purchaseMerchandiserList, expressDeliverGoodsList, purchaseArriveList]
}
const getTotalDataLength = (status: number) => {
  const { purchaseMerchandiserList, expressDeliverGoodsList, purchaseArriveList } = getStatusData(status)
  const newData = [purchaseMerchandiserList, expressDeliverGoodsList, purchaseArriveList]
  return newData.filter(item => item && item?.length)?.length ?? 0
}

// D2C24062611000002
/** 获取记录 */
const getOptions = (type: number) => {
  let data = []
  // purchaseMerchandiserList 采购中跟单记录expressMerchandiserList国内运输中跟单记录
  // 已采购
  if (type === 3) {
    data = Array.isArray(props.row.purchaseMerchandiserList) ? props.row.purchaseMerchandiserList : []
  }
  // 国内运输中
  if (type === 4) {
    data = Array.isArray(props.row?.expressMerchandiserList) ? props.row?.expressMerchandiserList : []
  }
  //  接口对应的purchaseMerchandiserList或者expressMerchandiserList为null的情况，会返回'-'需要过滤下
  if (Array.isArray(data)) {
    return data
  }
  return []
}

const defectiveAmount = isD2C() ? props.row.badConvertStockQuantity : props.row.defectiveAmount

const setStatus = (status: number) => {
  const statusList = (props.row.orderItemStatus || '').split(',').map((v: string) => Number(v))
  return statusList.includes(status)
}

const jumpCancelGoods = () => {
  const routerUrl: any = router.resolve(useRtfix('AbnormalOrder', {
    query: {
      abnormal: 'ApplyCancel',
      platformOrderNo2: props.orderNo,
      productSku: props.combineSku || props.row.productSku,
      processManner: '0'
    }
  }))
  window.open(routerUrl.href, '_blank')
}

const toStubstandardList = function (row: any) {
  router.push(
    useRtfix('SubstandardList', {
      query: {
        shopProductSku: row.shopProductSku
      }
    })
  )
}
const visible = ref(false)
const loading = ref(false)
// 不同状态点击的loading效果，为了解决点击一个另一个状态也处于loading的情况
const loadingObj: any = ref({})
// 查看物流信息
const openExpress = (status: number) => {
  const data = getOptions(status)

  loading.value = true
  loadingObj.value = { [status]: true }
  queryUserMerchandiser({
    orderItemStatus: status,
    systemOrderNo: props.row.systemOrderNo

  }).then((res) => {
    emit('open', res.data, props.row, status)
  }).finally(() => {
    loading.value = false
    loadingObj.value = { [status]: false }
  })
}
// 是否超时
const checkTime = (time: any) => {
  if (!time) return
  time = dayjs(new Date(time)).format('YYYY-MM-DD')
  return new Date(time + ' 23:59:59').getTime() < new Date().getTime()
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (__props.row?.orderItemStatus)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
        class: "word-break-en"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStatsEnum), (v, k) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (setStatus(Number(k)) && __props.row[productStatsKeyEnum[k]] > 0)
              ? (_openBlock(), _createElementBlock("p", { key: k }, [
                  (__props.cancelJump && Number(k) === 12)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: jumpCancelGoods,
                        class: _normalizeClass(`${getMt8px(k, true)}`)
                      }, [
                        _createElementVNode("span", null, _toDisplayString(v) + " (" + _toDisplayString(__props.row[productStatsKeyEnum[k]]) + ") ", 1)
                      ], 2))
                    : (_openBlock(), _createElementBlock("span", _hoisted_1, [
                        ((Number(k) !== 4 && Number(k) !== 3) || !__props.showExpress)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(`${getMt8px(k, true)}`)
                            }, _toDisplayString(v) + " (" + _toDisplayString(__props.row[productStatsKeyEnum[k]]) + ") ", 3))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(`express-status ${getMt8px(k, false)}`)
                            }, [
                              _createVNode(_component_el_button, {
                                type: "text",
                                class: "express-status-num",
                                onClick: _withModifiers(() => openExpress(Number(k)), ["stop"]),
                                loading: loadingObj.value[Number(k)]
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(v) + "(" + _toDisplayString(__props.row[productStatsKeyEnum[k]]) + ")", 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "loading"]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTotalData(Number(k)), (item, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  (item.length)
                                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                        key: 0,
                                        effect: "light",
                                        placement: "left",
                                        "popper-class": "express-drawer-tooltip-warn documentary-record-tooltip-warn "
                                      }, {
                                        content: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_2, [
                                            _createElementVNode("div", _hoisted_3, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (sonItem, sonIndex) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: sonIndex,
                                                  class: "tooltip-sigle-item"
                                                }, _toDisplayString(`${getText(sonItem)}：${!sonItem.time || sonItem.time === '-' ? _unref(t)('无2') : sonItem.time
                          }(${_unref(t)('X件').replace('X', sonItem.num)})`), 1))
                                              }), 128))
                                            ])
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(`estimated-time-arrival ${item[0].colour === 2 ? 'green' : 'red'} ${index > 1 && getTotalDataLength(Number(k)) > 1 ? 'mt-8px' : ''}`),
                                            innerHTML: getShowText(item)
                                          }, null, 10, _hoisted_4)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              (getNoText(Number(k)))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "estimated-time-arrival",
                                    innerHTML: getNoText(Number(k))
                                  }, null, 8, _hoisted_5))
                                : _createCommentVNode("", true)
                            ], 2))
                      ]))
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256)),
        (_unref(defectiveAmount))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_tooltip, {
                placement: "left",
                effect: "light",
                "popper-class": "tips"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_unref(t)('次品经您转为正品后，可视为正品下单，存在消费者不可接受的风险，请谨慎操作！平台不承担相关责任。')) + " ", 1),
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (toStubstandardList(__props.row)))
                    }, _toDisplayString(_unref(t)('查看转正记录>')), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Warning))
                      ]),
                      _: 1
                    }),
                    _createTextVNode(_toDisplayString(`${_unref(t)('含次品转正品')}(${_unref(defectiveAmount)})`), 1)
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (__props.row.locationRemind === 1 && _unref(isJA)())
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_el_tooltip, {
                content: _unref(t)('您下单的商品和利用的仓库不在一个城市，需要中国国内转运。商品从寄出到仓库通常需要3天时间，请耐心等待。'),
                placement: "top",
                effect: "light"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Warning))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["content"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})